/** Checks that a variable is not null or undefined. Used to avoid situations where 0 or empty string are seen as falsy values */
export const isDefinedVariable = (value: any) => {
  if (value === null || value === undefined) {
    return false;
  }

  return true;
};
